module.exports = require("zustand/shallow");